<template>
  <div>
    <a-breadcrumb :routes="routes" style="margin: 16px 0">
      <template slot="itemRender" slot-scope="{route, params, routes}">
        <span v-if="routes.indexOf(route) === routes.length - 1 & routes.indexOf(route) !== 0">{{route.name}}</span>
        <router-link v-else-if="routes.indexOf(route) === 0" :to="{ name: `${route.path}`}"><a-icon type="home" /></router-link>
        <router-link v-else :to="{ name: `${route.path}`}">{{route.name}}</router-link>
      </template>
    </a-breadcrumb>
  </div>
</template>
<script>
export default {
  data() {
    return {
      base: [
        {
          path: "home",
          name: "Home"
        }
      ]
    };
  },
  props: {
    crumbs: {
      type: Array,
      default: null
    }
  },
  computed: {
    routes() {
      return this.crumbs ? this.base.concat(this.crumbs) : this.base;
    }
  }
};
</script>